import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class CompanyService extends GenericService {
  constructor() {
    super('/vat_groups', axiosInstance);
  }
}

export default new CompanyService(); 